import {Type} from 'class-transformer'
import {AlertCircle} from 'react-feather'

import {Sku} from './Sku'

export class ShortageSummary {
  static type = 'shortagesummary'
  static typeDisplay = 'Shortage Summary'
  static icon = AlertCircle

  type = ShortageSummary.type
  typeDisplay = ShortageSummary.typeDisplay
  icon = ShortageSummary.icon

  guid: string = ''

  shortage: number = 0

  @Type(() => Sku)
  sku?: Sku
}
